import { Grid, Typography } from "@mui/material";
import { Control } from "react-hook-form";
import { Forms } from "@/types/form";
import constant from "@/utils/constant";
import { useParams } from "react-router-dom";
import { Params } from "@/types/utils";
import { Select, Input } from "@dippi/ui";
import { SELECT_ITEMS } from "@/utils/helpers";

interface Props {
    control: Control<Forms["Settings"]>;
}

const Base: React.FC<Props> = ({ control }) => {
    const { oid } = useParams<Params>();
    const isUpdate = Boolean(oid);

    return (
        <Grid item container xs={12} gap={constant.GRID_SPACING}>
            <Grid item xs={12}>
                <Typography variant="h3">Organization information</Typography>
            </Grid>
            <Grid item xl={3} md={5} sm={5} xs={12}>
                <Input
                    testId="settings-name-input"
                    name="title"
                    control={control}
                    disabled={isUpdate}
                    label="Organization name"
                />
            </Grid>
            <Grid item xl={3} md={5} sm={5} xs={12}>
                <Input
                    testId="settings-company-id-input"
                    name="companyId"
                    control={control}
                    disabled={isUpdate}
                    label="Organization ID"
                />
            </Grid>
            <Grid item xl={3} md={5} sm={5} xs={12}>
                <Select
                    name="business"
                    control={control}
                    label="Line of business"
                    items={SELECT_ITEMS.business}
                />
            </Grid>
        </Grid>
    );
};

export default Base;
